export default __webpack_public_path__ + "static/media/screen.e523ca2c.png";